import React from 'react'
import styled from 'styled-components'

import ConnectedDotLinkView from '../View/ConnectedDotLinkView'

const LinkContainer = styled.div`
margin: 10px;
`
const ConnectedDotCollectionView = (props) => {
  const { connectedDotCollection } = props
  return connectedDotCollection && connectedDotCollection.connectedDots.map((dot) => {
    return <LinkContainer key={dot.id}><ConnectedDotLinkView connectedDot={dot} /></LinkContainer>
  })
}

export default ConnectedDotCollectionView


// WEBPACK FOOTER //
// ./src/App/View/ConnectedDotCollectionView.js